import env from "../utilities/env";

const isAbsoluteURL = (url) => new RegExp("^(?:[a-z]+:)?//", "i").test(url);

const baseUrl = (url) => {
	return window.LEXUS?.baseUrl && !isAbsoluteURL(url)
		? `${window.LEXUS?.baseUrl}${url}`
		: url;
};

export function isSubCategory(menuType) {
	return (
		menuType === "links" ||
		menuType === "vehicleSelector" ||
		menuType === "tiles"
	);
}

export function showGarage(menuType) {
	return menuType === "vehicleSelector";
}

export function isExperienceFragment(menuType) {
	return (
		menuType === "xf" || menuType === "loggedIn" || menuType === "loggedOut"
	);
}

export function transformModels(headerMenuItems, loggedIn, version = 1) {
	return headerMenuItems.map(
		(
			{
				menuName,
				menuSpecsLine1,
				menuSpecsLine2,
				menuImage,
				menuLink,
				menuAltTag,
				copy,
				copy2,
				copy1,
				ctas = [],
				target,
			},
			index,
		) => ({
			id: menuName,
			asset: menuImage,
			alt: menuAltTag,
			title: menuName,
			copy: loggedIn ? copy : menuSpecsLine1,
			copy1,
			copy2: loggedIn ? copy2 : menuSpecsLine2,
			link: {
				href: menuLink,
				target,
			},
			[loggedIn || (version === 2 && index === 2) ? "links" : "ctas"]: ctas,
		}),
	);
}

export function transformSubcategories(headerMenuItems, version) {
	return headerMenuItems.map(({ menuName, menuLink, ctas = [] }) => ({
		[version !== 2 ? "subcategory" : "label"]: menuName,
		href: menuLink,
		links: ctas,
	}));
}

export function transformSubcategoryMenu(headerMenuSubCategories, version) {
	return headerMenuSubCategories.map(
		({ menuCategory, headerMenuItems = [], menuType }) => {
			if (menuType.startsWith("logged")) {
				return {
					label: menuCategory,
					loggedIn: menuType === "loggedIn" ? true : false,
					items: transformModels(
						headerMenuItems,
						menuType === "loggedIn" ? true : false,
						version,
					),
				};
			}
			return {
				label: menuCategory,
				type: menuType,
				items: transformModels(headerMenuItems),
			};
		},
	);
}

export default (
	{
		logoLink,
		searchEnabled,
		headerMenuCategories = [],
		headerId,
		subdomain,
		links = [],
	} = {},
	authConfig,
) => ({
	id: headerId,
	baseUrl: baseUrl(logoLink?.href || "/"),
	searchUrl: env("REACT_APP_SEARCH_PAGE_URL"),
	searchEnabled,
	menuItems: headerMenuCategories.map(
		({
			menuCategory,
			headerMenuItems = [],
			headerMenuSubCategories = [],
			menuType,
		}) => ({
			label: menuCategory,
			type: menuType,
			showGarage: isExperienceFragment(menuType),
			items: isSubCategory(menuType)
				? transformModels(headerMenuItems)
				: transformSubcategoryMenu(headerMenuSubCategories, 2),
		}),
	),
	links,
	authConfig,
});
